import { render } from "./UpComingReward.vue?vue&type=template&id=17450a82&scoped=true"
import script from "./UpComingReward.vue?vue&type=script&lang=js"
export * from "./UpComingReward.vue?vue&type=script&lang=js"

import "./UpComingReward.vue?vue&type=style&index=0&id=17450a82&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17450a82"]])

export default __exports__